module.exports = __webpack_public_path__ + "static/media/petergerritsen.6f2fe5bf.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/petergerritsen.webp
// module id = 656
// module chunks = 0